import React, { useContext } from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../../../../constants'
import { StickerBlock } from '../../../blocks'
import { TrashIcon } from '../../../icons'
import SourceThumbnail from '../../../source-thumbnail'
import { CreationToolUploadContext } from '../../manager'
import { CreationToolUploadSource } from '../../types'

const Container = styled(StickerBlock)`
    align-items: center;
    border-radius: ${BORDER_RADIUS_SMALL}px;
    display: flex;
    flex-shrink: 0;
    height: 100%;
    justify-content: center;
    overflow: hidden;
    position: relative;
    width: 50px;
`

const Image = styled(SourceThumbnail)`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

export const DragIcon = ({ className }: { className?: string }) => (
    <svg
        width="40px"
        height="40px"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={className}
    >
        <g id="icons/drag" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <polygon
                id="Line-2"
                fill="#C7C7C7"
                fillRule="nonzero"
                points="29.5714286 13.5 29.5714286 15.5 10.4285714 15.5 10.4285714 13.5"
            />
            <polygon
                id="Line-2"
                fill="#C7C7C7"
                fillRule="nonzero"
                points="29.5714286 19.5 29.5714286 21.5 10.4285714 21.5 10.4285714 19.5"
            />
            <polygon
                id="Line-2"
                fill="#C7C7C7"
                fillRule="nonzero"
                points="29.5714286 25.5 29.5714286 27.5 10.4285714 27.5 10.4285714 25.5"
            />
        </g>
    </svg>
)

const RemoveButton = styled.div`
    align-items: center;
    background: rgba(0, 0, 0, 0.9);
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    transition: opacity 0.15s ease-out;
    width: 100%;

    svg {
        width: 34px;
    }

    svg path:first-child {
        transition: transform 0.15s ease-out;
    }

    &:hover svg path:first-child {
        transform: rotate(-30deg) translate3d(-20%, 10%, 0);
    }
`

type Props = {
    source: CreationToolUploadSource
    showRemoveIcon?: boolean
}

const CreationUploadItemIcon = ({ source: { id, source }, showRemoveIcon }: Props) => {
    const { removeUploadSource } = useContext(CreationToolUploadContext)

    const onRemove = () => {
        removeUploadSource(id)
    }

    return (
        <Container>
            <Image source={source} />
            <RemoveButton style={{ opacity: showRemoveIcon ? 1 : 0 }} onClick={onRemove}>
                <TrashIcon />
            </RemoveButton>
        </Container>
    )
}

export default CreationUploadItemIcon
